import { useMutation } from "@tanstack/react-query";
import { removeTag } from "PFCore/services/activities/tags";
import { Id, MutationOptions } from "PFTypes";

import { useActivityInvalidate } from "../../activity";

type Payload = { activityId: Id; notificationRecipientIds?: Id[] };

export const useDeleteTag = (options: MutationOptions<Payload> = {}) => {
  const { invalidate: invalidateActivity } = useActivityInvalidate();

  return useMutation({
    mutationFn: ({ activityId, notificationRecipientIds }: Payload) =>
      removeTag(activityId, notificationRecipientIds),
    ...options,
    onSuccess: (...args) => {
      const { activityId } = args[1];

      invalidateActivity([activityId]);
      options?.onSuccess?.(...args);
    }
  });
};
